import Model from "@/models/Model";
import {ReportState} from "@/helpers/constants";
import UserSimple from "@/models/user/UserSimple";
import OrderSimple from "@/models/order/OrderSimple";
import BillSimple from "@/models/bill/BillSimple";
import {formatDuration} from "@/helpers/functions_asi";
import i18n from "@/i18n";

export default class ReportSimple extends Model {

	public state!: ReportState;

	public user!: UserSimple;
	public order!: OrderSimple;
	public bill!: BillSimple | null;
	public date!: string;

	public fromTime!: string;
	public toTime!: string;
	public breakDuration!: number;

	public static calculateTotalDurationMinutes(report: ReportSimple): number {
		const dFrom = new Date(report.fromTime).getTime();
		const dTo = new Date(report.toTime).getTime();
		return (dTo - dFrom) / 60000;
	}

	public static calculateWorkingDurationMinutes(report: ReportSimple): number {
		return this.calculateTotalDurationMinutes(report) - report.breakDuration;
	}

	public static breakDuration(report: ReportSimple): string {
		if (report.breakDuration === 0) {
			return i18n.t('uiTerms.noBreak').toString();
		}
		return formatDuration(report.breakDuration);
	}

	public static missionHourLines(report: ReportSimple): string[] {
		const dFrom = new Date(report.fromTime);
		const dTo = new Date(report.toTime);

		const fromDate = i18n.d(dFrom, 'short');
		const fromTime = i18n.d(dFrom, 'timeShort');
		const toDate = i18n.d(dTo, 'short');
		const toTime = i18n.d(dTo, 'timeShort');

		const lines = [];
		if (dFrom.getDate() === dTo.getDate()) {
			lines.push(i18n.t('uiTerms.timeRangeValues', {
				from: fromTime,
				to: toTime,
			}).toString());
		} else {
			lines.push(i18n.t('uiTerms.dateTimeRangeValues', {
				fromDate: fromDate,
				fromTime: fromTime,
				toDate: toDate,
				toTime: toTime,
			}).toString());
		}

		lines.push(formatDuration(ReportSimple.calculateTotalDurationMinutes(report)));
		return lines;
	}

	public static workingHours(report: ReportSimple): string {
		return formatDuration(ReportSimple.calculateWorkingDurationMinutes(report));
	}

}
